import { AmountValue, Inflation } from 'common/interfaces';
import { Currency } from 'enums';

export enum TargetFrequency {
  SINGLE = 'SINGLE',
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY',
  REPEAT_EVERY = 'REPEAT_EVERY',
  EMPTY = '',
}

export enum TargetType {
  STUDY = 'STUDY',
  VEHICLE = 'VEHICLE',
  TRAVEL = 'TRAVEL',
  WEDDING = 'WEDDING',
  LIVING = 'LIVING',
  CONSTRUCTION = 'CONSTRUCTION',
  CARE = 'CARE',
  DONATION = 'DONATION',
  RENT = 'RENT',
  OTHER = 'OTHER',
  PORTFOLIO_RENT = 'PORTFOLIO_RENT',
  EMPTY = '',
}

export enum FulfillmentGrade {
  NONE = 'NONE',
  PARTIAL = 'PARTIAL',
  FULL = 'FULL',
  IN_PROCESS = 'IN_PROCESS',
  EMPTY = '',
}

export interface Target {
  id?: string;
  type: TargetType; // enum
  title: string;
  value: AmountValue;
  frequency: TargetFrequency;
  repeatYears: string;
  since: string;
  until: string;
  fulfillment?: number;
  fulfillmentGrade?: FulfillmentGrade;
  active?: boolean;
  enabled: boolean;
  inflation: Inflation;
}

export interface TargetOptions {
  minYears: number;
  maxYears: number;
  minDate?: string;
  maxDate: string;
  type: string[];
  frequency: string[];
  inflationType: string[];
}

export interface TargetsData {
  targets: Target[];
  addingEnabled: boolean;
  options: TargetOptions;
}

export const getInitialValues = (currency: Currency) => ({
  type: TargetType.EMPTY,
  title: '',
  value: { value: 0, currency: currency },
  frequency: TargetFrequency.EMPTY,
  repeatYears: '',
  since: '',
  until: '',
  inflation: { enabled: true, rate: 0, valuation: false, type: '' },
  enabled: true,
});
